(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eilik-cart-bundle"] && !Shopify.designMode) return;
  try {
    
$("#customCartClose").on("click", function () {
  $("#customCart").removeClass("show");
  $("#customCartOverlay").removeClass("show");
});
$("#cartList").on("click", ".tools .remove", function () {
  var index = $(this).data("index") + 1;
  var params = {
    url: "/cart/change.js",
    data: {
      quantity: 0,
      line: index
    },
    dataType: "json"
  };
  $.post(params).done(function (state) {
    if (state.item_count === 0) {
      $("#customCart").removeClass("show");
      $("#customCartOverlay").removeClass("show");
    } else {
      window.cartData = state;
      updateList();
    }
  });
});
$("#cartList").on("change", ".ipt > input", function () {
  var index = $(this).data("index") + 1;
  var params = {
    url: "/cart/change.js",
    data: {
      quantity: $(this).val(),
      line: index
    },
    dataType: "json"
  };
  $.post(params).done(function (state) {
    if (state.item_count === 0) {
      $("#customCart").removeClass("show");
      $("#customCartOverlay").removeClass("show");
    } else {
      window.cartData = state;
      updateList();
    }
  });
});

var updateList = function updateList() {
  var html = "";
  window.cartData.items.forEach(function (item, index) {
    html += "<li>\n          <div class=\"img\">\n            <img src=\"".concat(item.image, "\" />\n          </div>\n          <div class=\"info\">\n            <div class=\"ptitle\">").concat(item.product_title, "</div>\n            <div class=\"variant\">").concat(item.variant_options.join(','), "</div>\n            <div class=\"price\">$").concat(Number((item.original_price / 100).toFixed(2)), "</div>\n          </div>\n          <div class=\"ipt\">\n            <input data-index=\"").concat(index, "\" id=\"updates_large_").concat(item.key, "\" class=\"cart__qty-input\" type=\"number\"\n                    name=\"updates[]\" value=\"").concat(item.quantity, "\" min=\"0\" pattern=\"[0-9]*\"\n                    data-quantity-input data-quantity-item=\"").concat(index, "\" data-quantity-input-desktop>\n          </div>\n          <div class=\"tools\">\n            <div  data-index=\"").concat(index, "\" class=\"remove\">\n            <img src=\"https://cdn.shopify.com/s/files/1/0601/5349/5720/files/x_800x800.png?v=1782803134\" >\n            </div>\n          </div>\n        </li>");
  });



  $("#cartList").html(html);

  $("#customCartTotal").html('$' + Number((window.cartData.items_subtotal_price / 100).toFixed(2)));
};

window.customCart = {
  update: function update(item) {
    var findIterm = window.cartData.items.find(function (m) {
      return m.id === item.id && item.variant_options.join(',') === m.variant_options.join(',');
    });

    if (findIterm) {
      findIterm.quantity = item.quantity;
    } else {
      window.cartData.items = [item].concat(window.cartData.items);
    }

	window.cartData.items_subtotal_price = 0;
	window.cartData.items.forEach(function(m) {
		window.cartData.items_subtotal_price += m.original_price * m.quantity;
	});

    updateList();
    $("#customCart").addClass("show");
    $("#customCartOverlay").addClass("show");
  }
};
$("#customCartOverlay").click(()=>{
    $("#customCart").removeClass("show");
    $("#customCartOverlay").removeClass("show");
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eilik-cart"] && !Shopify.designMode) return;
  try {
    
$("#customCartClose").on("click", function () {
  $("#customCart").removeClass("show");
  $("#customCartOverlay").removeClass("show");
});
$("#cartList").on("click", ".tools .remove", function () {
  var index = $(this).data("index") + 1;
  var params = {
    url: "/cart/change.js",
    data: {
      quantity: 0,
      line: index
    },
    dataType: "json"
  };
  $.post(params).done(function (state) {
    if (state.item_count === 0) {
      $("#customCart").removeClass("show");
      $("#customCartOverlay").removeClass("show");
    } else {
      window.cartData = state;
      updateList();
    }
  });
});
$("#cartList").on("change", ".ipt > input", function () {
  var index = $(this).data("index") + 1;
  var params = {
    url: "/cart/change.js",
    data: {
      quantity: $(this).val(),
      line: index
    },
    dataType: "json"
  };
  $.post(params).done(function (state) {
    if (state.item_count === 0) {
      $("#customCart").removeClass("show");
      $("#customCartOverlay").removeClass("show");
    } else {
      window.cartData = state;
      updateList();
    }
  });
});

var updateList = function updateList() {
  var html = "";
  window.cartData.items.forEach(function (item, index) {
    html += "<li>\n          <div class=\"img\">\n            <img src=\"".concat(item.image, "\" />\n          </div>\n          <div class=\"info\">\n            <div class=\"ptitle\">").concat(item.product_title, "</div>\n            <div class=\"variant\">").concat(item.variant_options.join(','), "</div>\n            <div class=\"price\">$").concat(Number((item.original_price / 100).toFixed(2)), "</div>\n          </div>\n          <div class=\"ipt\">\n            <input data-index=\"").concat(index, "\" id=\"updates_large_").concat(item.key, "\" class=\"cart__qty-input\" type=\"number\"\n                    name=\"updates[]\" value=\"").concat(item.quantity, "\" min=\"0\" pattern=\"[0-9]*\"\n                    data-quantity-input data-quantity-item=\"").concat(index, "\" data-quantity-input-desktop>\n          </div>\n          <div class=\"tools\">\n            <div  data-index=\"").concat(index, "\" class=\"remove\">\n            <img src=\"https://cdn.shopify.com/s/files/1/0601/5349/5720/files/x_800x800.png?v=1782803134\" >\n            </div>\n          </div>\n        </li>");
  });



  $("#cartList").html(html);

  $("#customCartTotal").html('$' + Number((window.cartData.items_subtotal_price / 100).toFixed(2)));
};

window.customCart = {
  update: function update(item) {
    var findIterm = window.cartData.items.find(function (m) {
      return m.id === item.id && item.variant_options.join(',') === m.variant_options.join(',');
    });

    if (findIterm) {
      findIterm.quantity = item.quantity;
    } else {
      window.cartData.items = [item].concat(window.cartData.items);
    }

	window.cartData.items_subtotal_price = 0;
	window.cartData.items.forEach(function(m) {
		window.cartData.items_subtotal_price += m.original_price * m.quantity;
	});

    updateList();
    $("#customCart").addClass("show");
    $("#customCartOverlay").addClass("show");
  }
};
$("#customCartOverlay").click(()=>{
    $("#customCart").removeClass("show");
    $("#customCartOverlay").removeClass("show");
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-dualEilik-jp-1"]) return;
  try {
    

$(document).ready(function() {
    $(".eeVidPc").click(function() {
        $(this).next(".vidOverlayPc").css("display", "block");
        $(this).next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $(".eeVidMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-dualEilik-jp"]) return;
  try {
    

$(document).ready(function() {
    $(".eeVidPc").click(function() {
        $(this).next(".vidOverlayPc").css("display", "block");
        $(this).next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $(".eeVidMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-dualEilik"]) return;
  try {
    

$(document).ready(function() {
    $(".eeVidPc").click(function() {
        $(this).next(".vidOverlayPc").css("display", "block");
        $(this).next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $(".eeVidMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-emailBottom-jp-1"]) return;
  try {
    

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Bottom-jp', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});



KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Bottom_jp', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-emailBottom-jp"]) return;
  try {
    

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Bottom-jp', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});


KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Bottom_jp', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-emailBottom"]) return;
  try {
    

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Bottom', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Bottom', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Bottom', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});




KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Bottom', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Bottom', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Bottom', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-emialMid"]) return;
  try {
    
KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Mid', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Mid', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Mid', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});



KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Mid', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Mid', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Mid', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-feature-jp-1"]) return;
  try {
    

window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

function videoScroll() {
    if (document.querySelectorAll('video[autoplay]').length > 0) {
        var windowHeight = window.innerHeight,
            videoEl = document.querySelectorAll('video[autoplay]');

        for (var i = 0; i < videoEl.length; i++) {

            var thisVideoEl = videoEl[i],
                videoHeight = thisVideoEl.clientHeight,
                videoClientRect = thisVideoEl.getBoundingClientRect().top;

            if (videoClientRect <= ((windowHeight) - (videoHeight * .5)) && videoClientRect >= (0 - (videoHeight * .5))) {
                thisVideoEl.play();
            } else {
                thisVideoEl.pause();
            }

        }
    }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-feature-jp"]) return;
  try {
    

window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

function videoScroll() {
    if (document.querySelectorAll('video[autoplay]').length > 0) {
        var windowHeight = window.innerHeight,
            videoEl = document.querySelectorAll('video[autoplay]');

        for (var i = 0; i < videoEl.length; i++) {

            var thisVideoEl = videoEl[i],
                videoHeight = thisVideoEl.clientHeight,
                videoClientRect = thisVideoEl.getBoundingClientRect().top;

            if (videoClientRect <= ((windowHeight) - (videoHeight * .5)) && videoClientRect >= (0 - (videoHeight * .5))) {
                thisVideoEl.play();
            } else {
                thisVideoEl.pause();
            }

        }
    }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-feature"]) return;
  try {
    

window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

function videoScroll() {

    if (document.querySelectorAll('video[autoplay]').length > 0) {
        var windowHeight = window.innerHeight,
            videoEl = document.querySelectorAll('video[autoplay]');

        for (var i = 0; i < videoEl.length; i++) {

            var thisVideoEl = videoEl[i],
                videoHeight = thisVideoEl.clientHeight,
                videoClientRect = thisVideoEl.getBoundingClientRect().top;

            if (videoClientRect <= ((windowHeight) - (videoHeight * .5)) && videoClientRect >= (0 - (videoHeight * .5))) {
                thisVideoEl.play();
            } else {
                thisVideoEl.pause();
            }

        }
    }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-gallery-jp"]) return;
  try {
    
$(document).ready(function() {
    $("#galleryListMobi").scrollLeft = 0;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-gallery"]) return;
  try {
    
$(document).ready(function() {
    $("#galleryListMobi").scrollLeft = 0;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-hero-jp-1"]) return;
  try {
    

gsap.from("#heroContainerPc-jp", {
    delay: 1.9,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#emailHeroContainerPc-jp", {
    delay: 2.2,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#liveHeroCoverPc", {
    delay: 2.2,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});



$(document).ready(function() {
    $("#heroVidBtnPc").click(function() {
        $(this).parent("#heroContainerPc-jp").next(".vidOverlayPc").css("display", "block");
        $(this).parent("#heroContainerPc-jp").next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $("#heroVidBtnMobi-jp").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });
})


// gsap.from("#headerLeadsContainerPc", {
//     delay: 2.5,
//     duration: 0.5,
//     opacity: 0,
// });

// Klaviyo form script
KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true,
    extra_properties: {
        $source: 'Top Pc JP',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true,
    success_url: "/pages/welcome-jp"
});


KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true,
    extra_properties: {
        $source: 'Top Mobi JP',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true,
    success_url: "/pages/welcome-jp"
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-hero-jp"]) return;
  try {
    

gsap.from("#heroContainerPc-jp", {
    delay: 1.9,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#emailHeroContainerPc-jp", {
    delay: 2.2,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#liveHeroCoverPc", {
    delay: 2.2,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});



$(document).ready(function() {
    $("#heroVidBtnPc").click(function() {
        $(this).parent("#heroContainerPc-jp").next(".vidOverlayPc").css("display", "block");
        $(this).parent("#heroContainerPc-jp").next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $("#heroVidBtnMobi-jp").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });
})


// gsap.from("#headerLeadsContainerPc", {
//     delay: 2.5,
//     duration: 0.5,
//     opacity: 0,
// });

// Klaviyo form script
KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: 'Top Pc JP',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});


KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true,
	success_url: "/pages/welcome-jp",
    extra_properties: {
        $source: 'Top Mobi JP',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-hero"]) return;
  try {
    

gsap.from("#heroContainerPc", {
    delay: 1.9,
    duration: 0.3,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#emailHeroContainerPc", {
    delay: 2.2,
    duration: 0.3,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

gsap.from("#liveHeroCoverPc, #groupHeroCoverPc", {
    delay: 2.2,
    duration: 0.7,
    opacity: 0,
    y: 300,
    ease: "back.out",
});

$(document).ready(function() {
    $("#heroVidBtnPc").click(function() {
        $(this).parent("#heroContainerPc").next(".vidOverlayPc").css("display", "block");
        $(this).parent("#heroContainerPc").next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });
	$("#heroVidBtnPc").mouseover(function(){
		//$("#playBtnHeroPc").css("font-size","23px");
		//$("#playIconHeroPc").css("width","11%");
		//console.log("in");
	});
	$("#heroVidBtnPc").mouseout(function(){
		//$("#playIconHeroPc").css("width","10%");
		//$("#playBtnHeroPc").css("font-size","22px");
		//console.log("out");
	});
    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $("#heroVidBtnMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });
})


KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikPc_Top', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});



KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
    }
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true
});

KlaviyoSubscribe.attachToForms('#email_signup_eilikMobi_Top', {
    hide_form_on_success: true,
    success_url: "/pages/welcome"
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-party-jp-1"]) return;
  try {
    

$(document).ready(function() {
    $(".party-vid-jp").click(function() {
        $(this).next(".vidOverlayPc").css("display", "block");
        $(this).next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $(".eeVidMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-Eilik-party-jp"]) return;
  try {
    

$(document).ready(function() {
    $(".party-vid-jp").click(function() {
        $(this).next(".vidOverlayPc").css("display", "block");
        $(this).next(".vidOverlayPc").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayPc").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayPc").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

    $(".eeVidMobi").click(function() {
        $(this).next(".vidOverlayMobi").css("display", "block");
        $(this).next(".vidOverlayMobi").find("video").trigger('play');
        $("body").css("overflow", "hidden");
    });

    $(".vidOverlayMobi").click(function() {
        $(this).css("display", "none");
        $(".vidOverlayMobi").children("video").trigger('pause');
        $("body").css("overflow", "auto");
    });

})

  } catch(e) { console.error(e); }
})();
})();
